const LS_KEY = 'logos-streak';

function getStreakData() {
  try {
    return JSON.parse(localStorage.getItem(LS_KEY) || '{}');
  } catch { return {}; }
}

function saveStreakData(data) {
  try { localStorage.setItem(LS_KEY, JSON.stringify(data)); } catch {}
}

export function recordDailyVisit() {
  const today = new Date().toISOString().slice(0, 10);
  const data = getStreakData();
  
  if (data.lastDate === today) return data; // Already recorded today

  const yesterday = new Date(Date.now() - 86400000).toISOString().slice(0, 10);
  const isConsecutive = data.lastDate === yesterday;

  const newData = {
    current: isConsecutive ? (data.current || 0) + 1 : 1,
    best: Math.max(data.best || 0, isConsecutive ? (data.current || 0) + 1 : 1),
    lastDate: today,
    totalDays: (data.totalDays || 0) + 1,
  };

  saveStreakData(newData);
  return newData;
}

export function getStreak() {
  const data = getStreakData();
  const today = new Date().toISOString().slice(0, 10);
  const yesterday = new Date(Date.now() - 86400000).toISOString().slice(0, 10);
  
  // If last visit wasn't today or yesterday, streak is broken
  if (data.lastDate !== today && data.lastDate !== yesterday) {
    return { current: 0, best: data.best || 0, totalDays: data.totalDays || 0, lastDate: data.lastDate || '' };
  }
  return {
    current: data.current || 0,
    best: data.best || 0,
    totalDays: data.totalDays || 0,
    lastDate: data.lastDate || '',
  };
}
